import axios from "axios";
import Select from "react-select";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Titulo9SeccionA from "./Autoevaluacion/Titulo9SeccionA";
import { MDBCollapse, MDBBtn } from "mdb-react-ui-kit";
import * as IoIcons from "react-icons/io";
import Titulo12SeccionA from "./Autoevaluacion/Titulo12SeccionA";
import Titulo2SeccionC from "./Autoevaluacion/Titulo2SeccionC";
import Titulo21SeccionC from "./Autoevaluacion/Titulo21SeccionC";
import Titulo23SeccionC from "./Autoevaluacion/Titulo23SeccionC";
import Titulo231SeccionC from "./Autoevaluacion/Titulo231SeccionC";
import Titulo24SeccionC from "./Autoevaluacion/Titulo24SeccionC";
import Titulo1SeccionD from "./Autoevaluacion/Titulo1SeccionD";
import Titulo2SeccionF from "./Autoevaluacion/Titulo2SeccionF";
import EquipoAutoevaluacion from "./Autoevaluacion/Equipos/SeccionG/EquipoAutoevaluacion";
import EquipoUrgencias from "./Autoevaluacion/Equipos/SeccionG/EquipoUrgencias";
import EquipoHospitalizacion from "./Autoevaluacion/Equipos/SeccionG/EquipoHospitalizacion";
import EquipoCuidadosIntensivo from "./Autoevaluacion/Equipos/SeccionG/EquipoCuidadosIntensivos";
import EquipoCirugia from "./Autoevaluacion/Equipos/SeccionG/EquipoCirugia";
import EquipoSangre from "./Autoevaluacion/Equipos/SeccionG/EquipoSangre";
import EquipoImagenes from "./Autoevaluacion/Equipos/SeccionG/EquipoImagenes";
import EquipoAmbulatorio from "./Autoevaluacion/Equipos/SeccionG/EquipoAmbulatorio";
import EquipoConsultaExterna from "./Autoevaluacion/Equipos/SeccionG/EquipoConsultaExterna";
import EquipoOncologia from "./Autoevaluacion/Equipos/SeccionG/EquipoOncologia";
import EquipoSaludPublica from "./Autoevaluacion/Equipos/SeccionG/EquipoSaludPublica";
import EquipoTerapias from "./Autoevaluacion/Equipos/SeccionG/EquipoTerapias";
import EquipoRehablitacionCardiaca from "./Autoevaluacion/Equipos/SeccionG/EquipoRehablitacionCardiaca";
import EquipoRehablitacion from "./Autoevaluacion/Equipos/SeccionG/EquipoRehabilitacion";
import EquipoSaludMental from "./Autoevaluacion/Equipos/SeccionG/EquipoSaludMental";
import EquipoOdontologia from "./Autoevaluacion/Equipos/SeccionG/EquipoOdontologia";
import EquipoOdontologiaEspecializada from "./Autoevaluacion/Equipos/SeccionG/EquipoOdontologiaEspecializada";
import EquipoCirugiaAmbulatoria from "./Autoevaluacion/Equipos/SeccionG/EquipoCirugiaAmbulatoria";
import EquipoImagenesTerapeuticas from "./Autoevaluacion/Equipos/SeccionG/EquipoImagenesTerapeuticas";
import EquipoPatologia from "./Autoevaluacion/Equipos/SeccionG/EquipoPatologia";
import EquipoDireccionamiento from "./Autoevaluacion/Equipos/SeccionF/EquipoDireccionamiento";
import EquipoGerencia from "./Autoevaluacion/Equipos/SeccionF/EquipoGerencia";
import EquipoTalentoHumano from "./Autoevaluacion/Equipos/SeccionF/EquipoTalentoHumano";
import EquipoAmbienteFisico from "./Autoevaluacion/Equipos/SeccionF/EquipoAbienteFisico";
import EquipoTecnologia from "./Autoevaluacion/Equipos/SeccionF/EquipoTecnologia";
import EquipoGerenciaInformacion from "./Autoevaluacion/Equipos/SeccionF/EquipoGerenciaInformacion";
import InfromacionAutoevaluacion from "./InfromacionAutoevaluacion";
import Titulo10SeccionA from "./Autoevaluacion/Titulo10SeccionA";
import Titulo4SeccionA from "./Autoevaluacion/Titulo4SeccionA";
import Titulo51SeccionA from "./Autoevaluacion/Titulo51SeccionA";
import Titulo52SeccionA from "./Autoevaluacion/Titulo52SeccionA";

import AdjuntoAutoevaluacion from "./AdjuntoAutoevaluacion";
import InfoAutoevaluacionOm from "./Autoevaluacion/InfoAutoevaluacionOmG";
import InfoOportunidadMejoraSecH from "./Autoevaluacion/InfoOportunidadMejoraSecH";
import Cookies from "universal-cookie";
import EstandarAsistencial from "./Autoevaluacion/Estandar/EstandarAsistencial";
import EstandarApoyo from "./Autoevaluacion/Estandar/EstandarApoyo";
import PerfilAutoevaluacio from "./Institucion/PerfilAutoevaluacion";
import InfoPerfil from "./Institucion/InfoPerfil";
import CambioEstado from "./Evaluador/CambiaEstado";
import InfoPerfilInstitucion2 from "./Institucion/InfoPerfilInstitucion2";

function ProcesoAutoevaluacion(props) {
  let params = useParams();
  let { id } = useParams();
  let { idInstitucion } = useParams();
  let { tipoSolicitud } = useParams();
  const cookie = new Cookies();
  const [showShow, setShowShow] = useState(false);
  const toggleShow = () => setShowShow(!showShow);

  const [showShow1, setShowShow1] = useState(false);
  const toggleShow1 = () => setShowShow1(!showShow1);

  const [showShow2, setShowShow2] = useState(false);
  const toggleShow2 = () => setShowShow2(!showShow2);

  const [showShow3, setShowShow3] = useState(false);
  const toggleShow3 = () => setShowShow3(!showShow3);

  const [showShow4, setShowShow4] = useState(false);
  const toggleShow4 = () => setShowShow4(!showShow4);

  const [showShow5, setShowShow5] = useState(false);
  const toggleShow5 = () => setShowShow5(!showShow5);

  const [showShow6, setShowShow6] = useState(false);
  const toggleShow6 = () => setShowShow6(!showShow6);

  const [showShow7, setShowShow7] = useState(false);
  const toggleShow7 = () => setShowShow7(!showShow7);

  const [showShow8, setShowShow8] = useState(false);
  const toggleShow8 = () => setShowShow8(!showShow8);

  const [showShow9, setShowShow9] = useState(false);
  const toggleShow9 = () => setShowShow9(!showShow9);

  const [showShow10, setShowShow10] = useState(false);
  const toggleShow10 = () => setShowShow10(!showShow10);

  const [showShow11, setShowShow11] = useState(false);
  const toggleShow11 = () => setShowShow11(!showShow11);

  const [showShow12, setShowShow12] = useState(false);
  const toggleShow12 = () => setShowShow12(!showShow12);

  const [showShow13, setShowShow13] = useState(false);
  const toggleShow13 = () => setShowShow13(!showShow13);

  const [showShow14, setShowShow14] = useState(false);
  const toggleShow14 = () => setShowShow14(!showShow14);

  const [showShow15, setShowShow15] = useState(false);
  const toggleShow15 = () => setShowShow15(!showShow15);

  const [showShow16, setShowShow16] = useState(false);
  const toggleShow16 = () => setShowShow16(!showShow16);

  const [showShow17, setShowShow17] = useState(false);
  const toggleShow17 = () => setShowShow17(!showShow17);

  const [showShow18, setShowShow18] = useState(false);
  const toggleShow18 = () => setShowShow18(!showShow18);

  const [showShow19, setShowShow19] = useState(false);
  const toggleShow19 = () => setShowShow19(!showShow19);

  const [showShow20, setShowShow20] = useState(false);
  const toggleShow20 = () => setShowShow20(!showShow20);

  const [showShow21, setShowShow21] = useState(false);
  const toggleShow21 = () => setShowShow21(!showShow21);

  const [showShow22, setShowShow22] = useState(false);
  const toggleShow22 = () => setShowShow22(!showShow22);

  const [showShow23, setShowShow23] = useState(false);
  const toggleShow23 = () => setShowShow23(!showShow23);

  const [showShow24, setShowShow24] = useState(false);
  const toggleShow24 = () => setShowShow24(!showShow24);

  const [showShow25, setShowShow25] = useState(false);
  const toggleShow25 = () => setShowShow25(!showShow25);

  const [showShow26, setShowShow26] = useState(false);
  const toggleShow26 = () => setShowShow26(!showShow26);

  const [showShow27, setShowShow27] = useState(false);
  const toggleShow27 = () => setShowShow27(!showShow27);

  const [showShow28, setShowShow28] = useState(false);
  const toggleShow28 = () => setShowShow28(!showShow28);

  const [showShow29, setShowShow29] = useState(false);
  const toggleShow29 = () => setShowShow29(!showShow29);

  const [showShow30, setShowShow30] = useState(false);
  const toggleShow30 = () => setShowShow30(!showShow30);

  const [showShow31, setShowShow31] = useState(false);
  const toggleShow31 = () => setShowShow31(!showShow31);

  const [showShow32, setShowShow32] = useState(false);
  const toggleShow32 = () => setShowShow32(!showShow32);

  const [showShow33, setShowShow33] = useState(false);
  const toggleShow33 = () => setShowShow33(!showShow33);

  const [showShow34, setShowShow34] = useState(false);
  const toggleShow34 = () => setShowShow34(!showShow34);

  const [showShow35, setShowShow35] = useState(false);
  const toggleShow35 = () => setShowShow35(!showShow35);

  const [showShow36, setShowShow36] = useState(false);
  const toggleShow36 = () => setShowShow36(!showShow36);

  const [showShow37, setShowShow37] = useState(false);
  const toggleShow37 = () => setShowShow37(!showShow37);

  const [showShow38, setShowShow38] = useState(false);
  const toggleShow38 = () => setShowShow38(!showShow38);

  const [showShow39, setShowShow39] = useState(false);
  const toggleShow39 = () => setShowShow39(!showShow39);

  const [showShow40, setShowShow40] = useState(false);
  const toggleShow40 = () => setShowShow40(!showShow40);
  const [showShow41, setShowShow41] = useState(false);
  const toggleShow41 = () => setShowShow41(!showShow41);

  const [showShow42, setShowShow42] = useState(false);
  const toggleShow42 = () => setShowShow42(!showShow42);

  const [showShow43, setShowShow43] = useState(false);
  const toggleShow43 = () => setShowShow43(!showShow43);

  const [showShow44, setShowShow44] = useState(false);
  const toggleShow44 = () => setShowShow44(!showShow44);

  const [country, setCountry] = useState([]);
  const [countryid, setCountryid] = useState("");
  const [st, setSt] = useState([]);
  const [stateid, setStateid] = useState("");
  const [city, setCity] = useState([]);
  const [postSubTitulo, setPostSubtitulo] = useState("");
  const [notificationNumber, setNotificationNumber] = useState(0);

  useEffect(() => {
    const getcountry = async () => {
      const rescountry = await fetch(
        "https://suadesarrollo.azurewebsites.net/Api/ObtenerSeccionAutoevaluacion",
      );
      const rescon = await rescountry.json();
      setCountry(await rescon);
    };
    getcountry();
  }, []);

  const handlecountry = (event) => {
    const getcountryid = event.target.value;
    setCountryid(getcountryid);
  };

  useEffect(() => {
    if (countryid != "") {
      const getstate = async () => {
        const resstate = await fetch(
          "https://suadesarrollo.azurewebsites.net/Api/ObtenerTituloAutoevaluacionPorSeccionId?SeccionId=" +
            countryid +
            "&Tipo=Todo",
        );
        const resst = await resstate.json();
        setSt(await resst);
      };
      getstate();
    }
  }, [countryid]);

  const handlestate = (event) => {
    const getstateid = event.target.value;
    setStateid(getstateid);
  };

  useEffect(() => {
    if (stateid != "") {
      const getcity = async () => {
        const rescity = await fetch(
          `https://suadesarrollo.azurewebsites.net/Api/ObtenerSubTituloAutoevaluacionPorTituloId?TituloId=` +
            stateid +
            "&Tipo=Autoevaluacion",
        );

        const rcity = await rescity.json();
        setCity(await rcity);
      };
      getcity();
    }
  }, [stateid]);

  const [postDescripcion, setPostDescripcion] = useState([]);
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaSubTitulos",
      data: {
        Seccion: countryid,
        tituloId: stateid,
        subTitulo: postSubTitulo,
        descripcion: postDescripcion,
        SolicitudId: id,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Guardado con exito !");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear" + error);
      });
  };
  const subId = postSubTitulo;

  const option = city.map((d) => ({
    value: d.id,
    label: d.subTitulo,
  }));
  const [selectedOption1, setSelectedOption1] = useState("");

  const handleTypeSelect1 = (e) => {
    setSelectedOption1(e.value);
  };

  const option1 = st.map((d) => ({
    value: d.id,
    label: d.titulo,
  }));

  return (
    <React.Fragment>
      <br></br>
      <div className="test">
        <div>
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-5">
                <div class="card-body">
                  <div class="table-responsive">
                    <hr />
                  </div>
                  <MDBBtn
                    outline
                    className="btn btn-light btn-user btn-block"
                    onClick={toggleShow1}
                  >
                    <IoIcons.IoIosPaper /> <left>Cuestionario del perfil</left>
                  </MDBBtn>
                  <MDBCollapse show={showShow1}>
                    {cookie.get("institucionid") != 1 ? (
                      <PerfilAutoevaluacio InstitucionId={idInstitucion} />
                    ) : (
                      <h1></h1>
                    )}
                  </MDBCollapse>
                  <hr />
                  <MDBBtn
                    outline
                    className="btn btn-light btn-user btn-block"
                    onClick={toggleShow44}
                  >
                    <IoIcons.IoIosPaper />{" "}
                    <left>Formulario de Autoevaluación </left>
                  </MDBBtn>
                  <MDBCollapse show={showShow44}>
                    {countryid == 5 ||
                    countryid == 6 ||
                    countryid == 7 ||
                    countryid == 8 ||
                    countryid == 9 ? (
                      <div>
                        {" "}
                        <br></br>
                        <br></br>
                        <br></br>
                        <select
                          className="btn btn-secondary btn-user btn-block text-left"
                          onChange={(e) => handlecountry(e)}
                        >
                          <option value="0">Seleccione la Sección </option>
                          {country.map((getcon, index) => (
                            <option key={index} value={getcon.id}>
                              {getcon.titulo}{" "}
                            </option>
                          ))}
                        </select>
                        <br></br>
                        <br></br>
                      </div>
                    ) : (
                      <table
                        class="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td>
                              <div class="card-header py-3">
                                <h6 class="m-0 font-weight-bold text-primary">
                                  SECCIÓN
                                </h6>
                              </div>
                              <select
                                className="btn btn-secondary btn-user btn-block text-left"
                                onChange={(e) => handlecountry(e)}
                              >
                                <option value="0">Seleccione </option>
                                {country.map((getcon, index) => (
                                  <option key={index} value={getcon.id}>
                                    {getcon.titulo}{" "}
                                  </option>
                                ))}
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="card-header py-3">
                                <h6 class="m-0 font-weight-bold text-primary">
                                  TÍTULO{" "}
                                </h6>
                              </div>
                              <select
                                className="btn btn-secondary btn-user btn-block text-left"
                                onChange={(e) => handlestate(e)}
                              >
                                <option value="0">Seleccione </option>
                                {st.map((getst, index) => (
                                  <option key={index} value={getst.id}>
                                    {getst.titulo}{" "}
                                  </option>
                                ))}
                              </select>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <div class="card-header py-3">
                                <h6 class="m-0 font-weight-bold text-primary">
                                  SUBTÍTULO
                                </h6>
                              </div>
                              <div className="text-left">
                                <select
                                  className="btn btn-secondary btn-user btn-block text-left"
                                  name="city"
                                  onChange={(e) =>
                                    setPostSubtitulo(e.target.value)
                                  }
                                >
                                  <option value="0">Seleccione </option>
                                  {city.map((gcity, index) => (
                                    <option key={index} value={gcity.id}>
                                      {" "}
                                      {gcity.subTitulo}{" "}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </td>
                            <hr />
                          </tr>
                          <label for="exampleFormControlTextarea1">
                            Descripcion
                          </label>

                          <textarea
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            rows="6"
                            onChange={(e) => setPostDescripcion(e.target.value)}
                          ></textarea>
                          <div className="col-md-3"></div>
                          {cookie.get("tipo_Usuario") == 2 ? (
                            <p>
                              <div className="text-center">
                                <AdjuntoAutoevaluacion
                                  idSolicitud={id}
                                  idSubtitulo={postSubTitulo}
                                />
                              </div>
                            </p>
                          ) : (
                            <h1></h1>
                          )}
                          <hr />
                        </tbody>
                        {cookie.get("tipo_Usuario") == 2 ? (
                          <p>
                            <center>
                              <a>
                                {" "}
                                <button
                                  className="btn btn-primary btn-user btn-block"
                                  onClick={postData}
                                >
                                  Guardar{" "}
                                </button>
                              </a>
                            </center>

                            <hr />
                          </p>
                        ) : (
                          <h1></h1>
                        )}
                      </table>
                    )}

                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      {countryid == 5 ? (
                        <div className="seccion A" id="">
                          <table
                            class="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow35}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Título: 4. Organos de direccion Sección A
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow35}>
                                <Titulo4SeccionA
                                  idSolicitud={id}
                                  idTitulo={countryid}
                                />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow36}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Título: 5.1. Junta Directiva Sección A
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow36}>
                                <Titulo51SeccionA idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow37}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Título: 5.2. Nivel Directivo Sección A
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow37}>
                                <Titulo52SeccionA idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Título: 9. Convenios docencia-servicio Sección
                                  A
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow}>
                                <Titulo9SeccionA idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow34}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Subtítulo: 8.4 Registre si aplica, respecto a
                                  los estudios de investigación en salud en
                                  curso y los desarrollados en los últimos 4
                                  años la siguiente información Sección A
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow34}>
                                <Titulo10SeccionA idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow1}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Título: 12. Acuerdos sindicales Sección A
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow1}>
                                <Titulo12SeccionA idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                          </table>
                        </div>
                      ) : (
                        <h2></h2>
                      )}

                      {countryid == 7 ? (
                        <div className="seccion C" id="">
                          <table
                            class="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow2}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Título: 2. Infraestructura física Seccion C
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow2}>
                                <Titulo2SeccionC idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow3}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Título: 2.1. Infraestructura física Metros
                                  Seccion C
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow3}>
                                <Titulo21SeccionC idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow4}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  2.3 Seguridad-Simulacros de emergencias.
                                  Seccion C
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow4}>
                                <Titulo23SeccionC idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow5}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Registre los simulacros realizados en el
                                  último año y frente a cada uno describa las
                                  dos principales recomendaciones y el
                                  seguimiento a la implementación de las mismas.
                                  Seccion C
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow5}>
                                <Titulo231SeccionC idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow6}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>2.4 Tecnología. Seccion C</left>
                              </MDBBtn>
                              <MDBCollapse show={showShow6}>
                                <Titulo24SeccionC idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                          </table>
                        </div>
                      ) : (
                        <h2></h2>
                      )}
                      {countryid == 8 ? (
                        <div className="seccion D" id="">
                          <table
                            class="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow7}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>Título: 1. Generalidades Seccion D</left>
                              </MDBBtn>
                              <MDBCollapse show={showShow7}>
                                <Titulo1SeccionD idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                          </table>
                        </div>
                      ) : (
                        <h2></h2>
                      )}

                      {countryid == 12 ? (
                        <div className="seccion F" id="">
                          <table
                            class="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow8}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Título 2: Equipo de mejoramiento institucional
                                  Seccion F
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow8}>
                                <Titulo2SeccionF idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                          </table>
                        </div>
                      ) : (
                        <h1></h1>
                      )}

                      {countryid == 13 ? (
                        <div className="seccion g" id="">
                          <table
                            class="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow9}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Equipo de autoevaluación hospitalario Seccion
                                  G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow9}>
                                <EquipoAutoevaluacion idSolicitud={id} />
                              </MDBCollapse>
                            </tr>

                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow30}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Equipo Primario de Mejoramiento de Urgencias
                                  Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow30}>
                                <EquipoUrgencias idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />

                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow43}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo Primario de Mejoramiento de Terapias
                                  (Física, Ocupacional, Lenguaje y Respiratoria)
                                  Sección G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow43}>
                                <EquipoTerapias idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow10}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo Primario de Mejoramiento de
                                  HospitalizaciónSeccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow10}>
                                <EquipoHospitalizacion idSolicitud={id} />
                              </MDBCollapse>
                            </tr>

                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow11}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo Primario de Mejoramiento de Cuidados
                                  Intensivos Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow11}>
                                <EquipoCuidadosIntensivo idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow12}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo Primario de Mejoramiento de Cirugía
                                  Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow12}>
                                <EquipoCirugia idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow13}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Laboratorio Clínico, Banco de Sangre y
                                  Patología Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow13}>
                                <EquipoSangre idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow31}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Imágenes Diagnósticos y Terapéuticas Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow31}>
                                <EquipoImagenes idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow14}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left> Equipo Ambulatorio</left>
                              </MDBBtn>
                              <MDBCollapse show={showShow14}>
                                <EquipoAmbulatorio idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow15}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo Primario de Mejoramiento de Consulta
                                  Externa Médica y Paramédica Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow15}>
                                <EquipoConsultaExterna idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow16}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo Primario de Mejoramiento de Oncología
                                  Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow16}>
                                <EquipoOncologia idSolicitud={id} />
                              </MDBCollapse>
                            </tr>

                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow17}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo Primario de Mejoramiento de Salud
                                  Pública y Promoción y Prevención Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow17}>
                                <EquipoSaludPublica idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow18}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  subtitulo 3.2.2 Equipos primarios de
                                  mejoramiento de servicios de Rehabilitación
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow18}>
                                <EquipoRehablitacion idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow19}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo primario de mejoramiento de
                                  Rehabilitación cardiaca, pulmonar y visual
                                  Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow19}>
                                <EquipoRehablitacionCardiaca idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow20}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Equipo primario de mejoramiento de Psicología
                                  y Salud mental Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow20}>
                                <EquipoSaludMental idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow32}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipos primarios de mejoramiento de
                                  Odontología Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow32}>
                                <EquipoOdontologia idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow21}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo primario de mejoramiento de Odontología
                                  especializada Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow21}>
                                <EquipoOdontologiaEspecializada
                                  idSolicitud={id}
                                />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow22}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo primario de mejoramiento de Cirugía
                                  ambulato Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow22}>
                                <EquipoCirugiaAmbulatoria idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow23}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo primario de mejoramiento de Imágenes
                                  Diagnósticas y Terapéuticas Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow23}>
                                <EquipoImagenesTerapeuticas idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow24}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo primario de mejoramiento de Patología
                                  Seccion G
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow24}>
                                <EquipoPatologia idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            {tipoSolicitud == 5 ? (
                              <tr>
                                <MDBBtn
                                  outline
                                  className="btn btn-light btn-user btn-block"
                                  onClick={toggleShow41}
                                >
                                  <IoIcons.IoIosPaper />{" "}
                                  <left>
                                    {" "}
                                    Estandares grupo Asistencial Seccion G
                                  </left>
                                </MDBBtn>
                                <MDBCollapse show={showShow41}>
                                  <EstandarAsistencial idSolicitud={id} />
                                </MDBCollapse>
                              </tr>
                            ) : (
                              <t></t>
                            )}
                            <hr />
                          </table>
                        </div>
                      ) : (
                        <h1></h1>
                      )}

                      {countryid == 14 ? (
                        <div className="seccion H" id="">
                          <table
                            class="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow25}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Equipo de autoevaluación de direccionamiento
                                  Seccion H
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow25}>
                                <EquipoDireccionamiento idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow26}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Equipo de autoevaluación de gerencia Seccion H
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow26}>
                                <EquipoGerencia idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow27}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo de autoevaluación de gerencia del
                                  talento humano Seccion H
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow27}>
                                <EquipoTalentoHumano idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />

                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow28}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo de autoevaluación de gerencia del
                                  ambiente físico Seccion H
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow28}>
                                <EquipoAmbienteFisico idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow29}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  {" "}
                                  Equipo de autoevaluación de gestión de
                                  tecnología Seccion H
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow29}>
                                <EquipoTecnologia idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                            <hr />
                            <tr>
                              <MDBBtn
                                outline
                                className="btn btn-light btn-user btn-block"
                                onClick={toggleShow33}
                              >
                                <IoIcons.IoIosPaper />{" "}
                                <left>
                                  Equipo de autoevaluación de gerencia de la
                                  información Seccion H
                                </left>
                              </MDBBtn>
                              <MDBCollapse show={showShow33}>
                                <EquipoGerenciaInformacion idSolicitud={id} />
                              </MDBCollapse>
                            </tr>
                          </table>
                        </div>
                      ) : (
                        <h1></h1>
                      )}
                      <hr />
                      {countryid == 14 ? (
                        <div className="seccion g" id="">
                          <table
                            class="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            {tipoSolicitud == 5 ? (
                              <tr>
                                <MDBBtn
                                  outline
                                  className="btn btn-light btn-user btn-block"
                                  onClick={toggleShow41}
                                >
                                  <IoIcons.IoIosPaper />{" "}
                                  <left> Estandares grupo Apoyo Seccion H</left>
                                </MDBBtn>
                                <MDBCollapse show={showShow41}>
                                  <EstandarApoyo idSolicitud={id} />
                                </MDBCollapse>
                              </tr>
                            ) : (
                              <x></x>
                            )}

                            <hr />
                          </table>
                        </div>
                      ) : (
                        <h1></h1>
                      )}
                    </table>
                    <CambioEstado idSolicitud={id} />
                  </MDBCollapse>

                  <hr />
                  <MDBBtn
                    outline
                    className="btn btn-light btn-user btn-block"
                    onClick={toggleShow2}
                  >
                    <IoIcons.IoIosPaper />{" "}
                    <left>Información del perfil autoevaluación</left>
                  </MDBBtn>
                  <MDBCollapse show={showShow2}>
                    {cookie.get("institucionid") != 1 ? (
                      <InfoPerfilInstitucion2
                        idInstitucion={cookie.get("institucionid")}
                      />
                    ) : (
                      <h1></h1>
                    )}
                  </MDBCollapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ProcesoAutoevaluacion;
